import { http } from './http'
import { TPermissionTypes } from '../constants/menu'

export interface IFestivalEdition {
  id: string
  name: string
  active: boolean
  startDate: number
  endDate: number
}

export interface IFestivalMenuItem {
  id: string
  name: string
  platformName: string
  website: string
  editions: IFestivalEdition[]
}

export type Permission = {
  id: string
  name: string
  type: TPermissionTypes
  ordinal: number
  isDefault: boolean
  view: boolean
  edit: boolean
}

type festivalsPermission = {
  festivalName: string
  permissions: Permission[]
}

export interface IUserProfile {
  id: string
  firstName: string
  lastName: string
  email: string
  password: string
  festivalsPermissions: festivalsPermission[]
  superAdmin: boolean
}

export interface IUserProfilePayload {
  id: string
  firstName: string
  lastName: string
  email: string
  password: string | null
}

export const getFestivalsMenu = () =>
  http.get<IFestivalMenuItem[]>('/operations/festivals')

export const getUserProfile = () =>
  http.get<IUserProfile>('/operations/dashboard-users/my-profile')

export const updateUserProfile = (data: IUserProfilePayload) =>
  http.put<IUserProfile>('/operations/dashboard-users/my-profile', data)
